/* eslint-disable @typescript-eslint/no-unused-vars */
import { locationCellStatusStyle } from './location-cell-status-style';
import { underlineLinkStyle } from './shared-styles-from-theme-fluent';

export const locationBidGridStyle = ({ palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({

  '& .toggle-campaign-settings-switch': {
    paddingRight: '8px !important',
    marginTop: 3,
    display: 'inline-block',
    float: 'left',
  },

  '& .change-mode-link': {
    paddingLeft: 4,
    verticalAlign: 'middle',
    ...underlineLinkStyle({ palette, elementLocator: '' }),
  },

  '& .location-bid-grid-container': {
    '&.show-cashback-percent': {
      '& .table-container': {
        width: '966px !important',
      },
    },
    '& thead>tr': {
      '& th:nth-child(1)': {
        borderRight: '0 !important',
        width: 'auto !important',
      },
      '& th:nth-child(2)': {
        borderRight: '0 !important',
        width: '333px !important',
      },
    },
    '& .table': {
      '& .col-location': {
        width: 'auto !important',
        borderLeft: '0 !important',
      },

      '& .col-bid': {
        width: 'auto !important',
      },

      '& .cashback-percent-input, & .inherit-value-span': {
        marginRight: 10,
        width: 66,
      },

      '& .cashback-input-container, & .inherit-cashback-value': {
        display: 'inline-block',

        '& .input-group-addon': {
          padding: 0,
          verticalAlign: 'middle',
          lineHeight: '30px',
        },
      },

      '& .cashback-option-select': {
        width: '180px !important',
        marginRight: 8,
      },
    },
  },

  '& .location-bid-grid, .excluded-location-grid, .advance-targeting-grid, & .location-bid-grid-container': {
    margin: 0,
    width: 716,
    minWidth: 716,
    '& .form-control': {
      display: 'inline-block',
    },

    '& .table': {
      marginTop: 8,
      marginBottom: 8,

      '& th, td': {
        lineHeight: '19px',
        color: palette.neutralPrimary,
        fontWeight: 'normal',
        paddingLeft: 8,
        paddingRight: 8,
        verticalAlign: 'middle !important',
        height: '42px',
      },

      '& thead>tr': {
        '& th:nth-child(1)': {
          borderRight: '0 !important',
        },

        '& th:nth-child(2)': {
          borderLeft: '0 !important',
        },
        '& th:nth-child(3)': {
          borderLeft: '0 !important',
        },
      },

      '& tbody>tr': {
        '& td': {
          border: `1px solid ${palette.neutralLight}`,
        },

        '& td:nth-child(1)': {
          borderRight: 0,
        },

        '& td:nth-child(2)': {
          borderLeft: 0,
        },
      },

      '& .col-icon': {
        width: 32,
        borderRight: '0 !important',
        paddingLeft: 16,
        paddingRight: 0,

        '& .map-icon__pin--included, .map-icon__pin--excluded': {
          fontSize: 16,
          lineHeight: '19px',
        },
      },

      '& .col-location': {
        width: 333,
        borderLeft: '0 !important',
      },

      '& .col-bid': {
        width: 350,
        padding: '5px 8px',

        '& .location-target-bid-grid-cell': {
          '& .bidBoost-options': {
            width: 135,
            marginRight: 8,
          },

          '& .bidBoost-percentValue': {
            marginRight: 8,
            width: 66,
          },
        },
      },
    },
    ...locationCellStatusStyle({ iconFontFamily }),
  },

  '& .excluded-location-grid': {
    '& .col-location': {
      width: '684px !important',
    },
  },

  '& .location-bid-pager-view, .excluded-location-pager-view': {
    height: 'auto !important',
  },
});
